import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';

import { Article } from '../models/article.model';

@Injectable({
    providedIn: 'root',
})
export class ArticleService {
    articles: Article[] = [];
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    private readonly ARTICLE_BASE_URL: string = '/api/customer_support/articles';

    constructor(private httpClient: HttpClient) {}

    getArticles(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(this.ARTICLE_BASE_URL);
    }

    getArticleById(id: Guid): Observable<Article> {
        return this.httpClient.get<Article>(this.ARTICLE_BASE_URL + '/' + id);
    }

    createArticle(article: Article): Observable<Article> {
        return this.httpClient.post<Article>(this.ARTICLE_BASE_URL, article, this.httpOptions);
    }

    updateArticle(article: Article): Observable<Article> {
        return this.httpClient.put<Article>(this.ARTICLE_BASE_URL + '/' + article.id, article, this.httpOptions);
    }

    removeArticle(id: Guid): Observable<Guid> {
        return this.httpClient.delete<Guid>(this.ARTICLE_BASE_URL + '/' + id);
    }
}
